import React, { createContext, useContext, useState, useEffect } from 'react';

const PaymentContext = createContext();

export const usePayment = () => {
  const context = useContext(PaymentContext);
  if (!context) {
    throw new Error('usePayment must be used within a PaymentProvider');
  }
  return context;
};

export const PaymentProvider = ({ children }) => {
  const [pendingOrder, setPendingOrder] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState(null);

  // Load pending order from localStorage on mount
  useEffect(() => {
    const storedOrder = localStorage.getItem('pendingPaymentOrder');
    const storedStatus = localStorage.getItem('paymentStatus');
    
    if (storedOrder) {
      try {
        setPendingOrder(JSON.parse(storedOrder));
      } catch (error) {
        console.error('Error parsing pending order from localStorage:', error);
        localStorage.removeItem('pendingPaymentOrder');
      }
    }
    
    if (storedStatus) {
      try {
        setPaymentStatus(JSON.parse(storedStatus));
      } catch (error) {
        console.error('Error parsing payment status from localStorage:', error);
        localStorage.removeItem('paymentStatus');
      }
    }
  }, []);

  // Save pending order to localStorage whenever it changes
  useEffect(() => {
    if (pendingOrder) {
      localStorage.setItem('pendingPaymentOrder', JSON.stringify(pendingOrder));
    } else {
      localStorage.removeItem('pendingPaymentOrder');
    }
  }, [pendingOrder]);

  // Save payment status to localStorage whenever it changes
  useEffect(() => {
    if (paymentStatus) {
      localStorage.setItem('paymentStatus', JSON.stringify(paymentStatus));
    } else {
      localStorage.removeItem('paymentStatus');
    }
  }, [paymentStatus]);

  const setOrderForPayment = (orderData) => {
    setPendingOrder(orderData);
  };

  const clearPendingOrder = () => {
    setPendingOrder(null);
    localStorage.removeItem('pendingPaymentOrder');
  };

  const updatePaymentStatus = (status) => {
    setPaymentStatus(status);
  };

  const clearPaymentStatus = () => {
    setPaymentStatus(null);
    localStorage.removeItem('paymentStatus');
  };

  const value = {
    pendingOrder,
    paymentStatus,
    setOrderForPayment,
    clearPendingOrder,
    updatePaymentStatus,
    clearPaymentStatus
  };

  return (
    <PaymentContext.Provider value={value}>
      {children}
    </PaymentContext.Provider>
  );
};

